import Exception from "../../shared/exception/Exception";
import AbstractSession from "../../shared/session/AbstractSession";
import {Administration} from "@softvision/webpdf-wsclient-9-typescript/lib/session/Administration";
import OAuthContext from "../OAuthContext";

export default class OAuthSession extends AbstractSession<OAuthContext, OAuthSession> {
	public async initialize(): Promise<void> {
		await this.info.fetch();
	}

	public async handleException(exception: Error, showMessage?: boolean): Promise<Exception> {
		return Exception.parseException(exception);
	}

	protected createAdministration(): Administration {
		// not needed in OAuth
		return {} as Administration;
	}
}